// extracted by mini-css-extract-plugin
export default {"chatPage":"Chat_chatPage__i0cUI","chatHeader":"Chat_chatHeader__02rXB","logoutButton":"Chat_logoutButton__FYEzM"};